/**
 * Mogelijk dubbele draaidagen: records van hetzelfde project waarvan de ene (start)dag binnen het
 * bereik van een meerdaagse draaidag van dat project valt.
 *
 * Waarom: elke Outlook-afspraak wordt een eigen draaidag. Scheepens [9607] stond eerst als losse
 * dagafspraken in Outlook en later als één afspraak van 13–16 okt; het verwijderen van de losse
 * afspraken kwam met vertraging door (Make/Airtable), dus stonden ze even dubbel (Robin, 16 okt 2026).
 * We verbergen niets: parallelle teams of opties op dezelfde dag komen echt voor. Alleen markeren.
 *
 * @param items [{ id, projectnummer, start: 'YYYY-MM-DD', eind: 'YYYY-MM-DD' (inclusief) }]
 * @returns Set met de ids die mogelijk dubbel staan (zowel de losse dag als de meerdaagse balk)
 */
export function mogelijkDubbeleDraaidagen(items) {
  const perProject = new Map();
  (items || []).forEach((it) => {
    const nr = String(it?.projectnummer ?? '').trim();
    if (!it?.id || !nr || !it.start) return;
    const eind = it.eind && it.eind >= it.start ? it.eind : it.start;
    if (!perProject.has(nr)) perProject.set(nr, []);
    perProject.get(nr).push({ id: it.id, start: it.start, eind });
  });
  const dubbel = new Set();
  perProject.forEach((lijst) => {
    const meerdaags = lijst.filter((x) => x.eind > x.start);
    if (!meerdaags.length) return;
    lijst.forEach((x) => {
      meerdaags.forEach((balk) => {
        if (balk.id === x.id) return;
        if (x.start >= balk.start && x.start <= balk.eind) {
          dubbel.add(x.id);
          dubbel.add(balk.id);
        }
      });
    });
  });
  return dubbel;
}

export const DUBBEL_TOOLTIP = 'Staat mogelijk dubbel — controleer Outlook';
